import React, { Component } from 'react';
import s from './styles.module.css';
import {ReactComponent as DnaSpinner} from './dna-spinner.svg';

export default class HelixSpinner extends Component {
  render() {
    return (
      <div className={s.container}>
        <div className={s.svg}><DnaSpinner /></div>
      </div>
    );
  }
}

